export enum ParameterTypeEnum {
  Pm1 = 0,
  Pm2_5 = 1,
  Pm10 = 2,
  RespirablePm = 3,
  Humidity = 4,
  Temperature = 5,
  Latitude = 6,
  Longitude = 7,
  Lavg = 8,
  Ozone = 9,
  SO2 = 10,
  NO2 = 11,
  CO = 12,
  CO2 = 13,
  TVOC = 14,
  // Pm1_A = 15,
  // Pm2_5_A = 16,
  // Pm10_A = 17,
  // RespirablePm_A = 18,
  BinMass = 19,
  BatteryVoltage = 20,
  ChargingVoltage = 21,
  ChargingCurrent = 22,
  SystemCurrent = 23,
  BatteryPercentage = 24,
  SignalStrength = 25,
  PowerState = 26,
  BatteryCharging = 27,
  Orientation = 28,
  WindDirection = 29,
  WindSpeed = 30,
  Count0_3 = 31,
  Count0_5 = 32,
  Count1_0 = 33,
  Count2_5 = 34,
  Count5_0 = 35,
  Count10 = 36,
  DewPoint = 37,
  Pressure = 38,
  Rainfall = 39,
  H2S = 40,
  NO = 41,
  MeasuredRCS = 42,
  FlowRate = 43,
  FeelsLike = 44,
}

export enum ParameterFieldEnum {
  pm1 = ParameterTypeEnum.Pm1,
  pm2_5 = ParameterTypeEnum.Pm2_5,
  pm10 = ParameterTypeEnum.Pm10,
  respirablePm = ParameterTypeEnum.RespirablePm,
  hum = ParameterTypeEnum.Humidity,
  tempC = ParameterTypeEnum.Temperature,
  lat = ParameterTypeEnum.Latitude,
  lon = ParameterTypeEnum.Longitude,
  lavg = ParameterTypeEnum.Lavg,
  ozone = ParameterTypeEnum.Ozone,
  sO2 = ParameterTypeEnum.SO2,
  co = ParameterTypeEnum.CO,
  nO2 = ParameterTypeEnum.NO2,
  cO2 = ParameterTypeEnum.CO2,
  tvoc = ParameterTypeEnum.TVOC,
  // Pm1_A = 15,
  // Pm2_5_A = 16,
  // Pm10_A = 17,
  // RespirablePm_A = 18,
  binMass = ParameterTypeEnum.BinMass,
  batt_volt = ParameterTypeEnum.BatteryVoltage,
  pressure = ParameterTypeEnum.Pressure,
  rainfall = ParameterTypeEnum.Rainfall,
  dewPoint = ParameterTypeEnum.DewPoint,
  pm0_3Particles = ParameterTypeEnum.Count0_3,
  pm0_5Particles = ParameterTypeEnum.Count0_5,
  pm1_0Particles = ParameterTypeEnum.Count1_0,
  pm2_5Particles = ParameterTypeEnum.Count2_5,
  pm5_0Particles = ParameterTypeEnum.Count5_0,
  pm10Particles = ParameterTypeEnum.Count10,
  windDir = ParameterTypeEnum.WindDirection,
  windSpeed = ParameterTypeEnum.WindSpeed,
  batteryPercentage = ParameterTypeEnum.BatteryPercentage,
  signal_strength = ParameterTypeEnum.SignalStrength,
  sys_current = ParameterTypeEnum.SystemCurrent,
  powerState = ParameterTypeEnum.PowerState,
  batteryCharging = ParameterTypeEnum.BatteryCharging,
  bus_volt = ParameterTypeEnum.ChargingVoltage,
  current = ParameterTypeEnum.ChargingCurrent,
  accel = ParameterTypeEnum.Orientation,
  trolex_MeasuredRCS = ParameterTypeEnum.MeasuredRCS,
  trolex_FlowRate_ml_min = ParameterTypeEnum.FlowRate,
  h2s = ParameterTypeEnum.H2S,
  no = ParameterTypeEnum.NO,
  feelsLikeC = ParameterTypeEnum.FeelsLike,
}
